import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=2aca77c8&scoped=true"
import script from "./Form.ts?vue&type=script&lang=ts&external"
export * from "./Form.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aca77c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aca77c8')) {
      api.createRecord('2aca77c8', component.options)
    } else {
      api.reload('2aca77c8', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=2aca77c8&scoped=true", function () {
      api.rerender('2aca77c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Marketers/components/Form/Form.vue"
export default component.exports